<template>
  <section class="l-content">
    <el-card>
      <el-form :model="formData" label-width="200px">
        <el-form-item label="AI合格分数阈值" prop="pass_score">
          <el-input-number v-model="formData.pass_score" :min="0" :max="100"></el-input-number>
          <div class="tips">分数大于等于该值判定为合格，默认80分</div>
        </el-form-item>
        <el-form-item label="最大上传图片数量" prop="max_images">
          <el-input-number v-model="formData.max_images" :min="1" :max="5"></el-input-number>
          <div class="tips">工人端最多可以上传几张清洁照片，默认3张</div>
        </el-form-item>
        <el-form-item label="图片压缩最大宽度" prop="image_max_width">
          <el-input-number v-model="formData.image_max_width" :min="400" :max="2000" :step="100"></el-input-number>
          <div class="tips">发送给AI分析前会将图片压缩到该宽度以内，默认800像素</div>
        </el-form-item>
        <el-form-item label="图片压缩质量" prop="image_quality">
          <el-input-number v-model="formData.image_quality" :min="50" :max="100" :step="5"></el-input-number>
          <div class="tips">JPEG压缩质量，数值越大质量越好文件越大，默认80</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveConfig">保存设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CleanConfig',
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      formData: {
        pass_score: 80,
        max_images: 3,
        image_max_width: 800,
        image_quality: 80
      }
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    async loadConfig() {
      const list = await this.$lgh.get('api/clean/config/get', {
        enterpriseCode: this.userInfo.enterpriseCode
      })
      if (list && list.length > 0) {
        list.forEach(item => {
          if (this.formData.hasOwnProperty(item.config_key)) {
            if (typeof this.formData[item.config_key] === 'number') {
              this.formData[item.config_key] = parseInt(item.config_value)
            } else {
              this.formData[item.config_key] = item.config_value
            }
          }
        })
      }
    },
    async saveConfig() {
      const updates = [
        { key: 'pass_score', value: this.formData.pass_score, desc: 'AI合格分数阈值' },
        { key: 'max_images', value: this.formData.max_images, desc: '最大上传图片数量' },
        { key: 'image_max_width', value: this.formData.image_max_width, desc: '图片压缩最大宽度' },
        { key: 'image_quality', value: this.formData.image_quality, desc: '图片压缩质量' }
      ]

      for (const item of updates) {
        await this.$lgh.get('api/clean/config/update', {
          enterpriseCode: this.userInfo.enterpriseCode,
          configKey: item.key,
          configValue: item.value.toString(),
          configDesc: item.desc
        })
      }

      this.$lgh.notifySuccess('保存成功')
      this.loadConfig()
    }
  }
}
</script>

<style scoped>
.tips {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}
</style>
